import { call, put, takeLatest } from 'redux-saga/effects';
import { accountStatusFail, accountStatusLoad, accountStatusSuccess, coreValueFail, coreValueLoad, coreValuesSuccess, emailSearchFail, emailSearchLoad, emailSearchSuccess, freezeProfileFail, freezeProfileLoad, freezeProfileSuccess, getPostFail, getPostListLoad, getPostListSuccess, makeSuperUserFail, makeSuperUserLoad, makeSuperUserSuccess, removeProfileFail, removeProfileLoad, removeProfileSuccess, userCommentListFail, userCommentListLoad, userCommentListSuccess, userDetailFail, userDetailLoad, userDetailSuccess, userListFail, userListLoad, userListSuccess } from '../slices/user.slice';
import { PostListApi, accountStatusApi, coreValueStatusApi, emailSearchApi, freezeProfileApi, makeSuperUserApi, removeProfileApi, userCommentListApi, userDetailApi, userListApi } from '../Api/api';
import { toast } from 'react-toastify';


function* accountStatusSaga(action) {
    try {
        const response = yield call(accountStatusApi, action.payload);
        if (response?.status == 0) {
            yield put(accountStatusSuccess(response?.result?.data));
        }
        else {
            yield put(accountStatusFail());
        }
    } catch (error) {
        yield put(accountStatusFail());
    }
}

function* coreValueSaga(action) {
    try {
        const response = yield call(coreValueStatusApi, action.payload);
        if (response?.status == 0) {
            yield put(coreValuesSuccess(response?.result?.data));
        }
        else {
            yield put(coreValueFail());
        }
    } catch (error) {
        yield put(coreValueFail());
    }
}

function* userListSaga(action) {
    try {
        const response = yield call(userListApi, action.payload);
        if (response?.status == 0) {
            yield put(userListSuccess(response?.result?.data));
        }
        else {
            yield put(userListFail());
        }
    } catch (error) {
        yield put(userListFail());
    }
}

function* userDetailSaga(action) {
    try {
        const response = yield call(userDetailApi, action.payload);
        if (response?.status == 0) {
            yield put(userDetailSuccess(response?.result?.data));
        }
        else {
            yield put(userDetailFail());
        }
    } catch (error) {
        yield put(userDetailFail());
    }
}

function* freezeProfileSaga(action) {
    try {
        const response = yield call(freezeProfileApi, action.payload);
        if (response?.status == 0) {
            toast.success(response?.result?.message)
            yield put(freezeProfileSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(freezeProfileFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(freezeProfileFail());
    }
}

function* removeProfileSaga(action) {
    try {
        const response = yield call(removeProfileApi, action.payload);
        if (response?.status == 0) {
            toast.success(response?.result?.message)
            yield put(removeProfileSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(removeProfileFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(removeProfileFail());
    }
}

function* emailSearchSaga(action) {
    try {
        const response = yield call(emailSearchApi, action.payload);
        if (response?.status == 0) {
            yield put(emailSearchSuccess(response?.result?.data));
        }
        else {
            toast.error(response?.result?.message)
            yield put(emailSearchFail());
        }
    } catch (error) {
        toast.error(error)
        yield put(emailSearchFail());
    }
}

function* postListSaga(action) {
    try {
        const response = yield call(PostListApi, action.payload)
        if (response.status === 0) {
            yield put(getPostListSuccess(response.result.data));
        } else {
            yield put(getPostFail());
        }
    } catch {
        yield put(getPostFail());
    }
}

function* userCommentListSaga(action) {
    try {
        let data = yield call(userCommentListApi, action.payload);
        if (data.status === 0) {
            yield put(userCommentListSuccess(data.result.data));
        } else {
            yield put(userCommentListFail());
        }
    } catch {
        yield put(userCommentListFail());
    }
}

function* makeSuperUserSaga(action) {
    try {
        let data = yield call(makeSuperUserApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message)
            yield put(userDetailLoad(action.payload));
            yield put(makeSuperUserSuccess());
        } else {
            toast.error(data?.result?.message)
            yield put(makeSuperUserFail());
        }
    } catch (error) {
        toast.error("Something went wrong")
        yield put(makeSuperUserFail());
    }
}


function* UserSaga() {
    yield takeLatest(accountStatusLoad.type, accountStatusSaga);
    yield takeLatest(coreValueLoad.type, coreValueSaga);
    yield takeLatest(userListLoad.type, userListSaga);
    yield takeLatest(userDetailLoad.type, userDetailSaga);
    yield takeLatest(freezeProfileLoad.type, freezeProfileSaga);
    yield takeLatest(removeProfileLoad.type, removeProfileSaga);
    yield takeLatest(emailSearchLoad.type, emailSearchSaga);
    yield takeLatest(getPostListLoad.type, postListSaga);
    yield takeLatest(userCommentListLoad.type, userCommentListSaga);
    yield takeLatest(makeSuperUserLoad.type, makeSuperUserSaga);



}

export default UserSaga;